import React, { Component } from 'react';
import Layout from "../components/Layout";

class App extends Component {
  render() {
    return (
      <Layout />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.js